module.exports = __webpack_public_path__ + "img/male_business.e84f858e.svg";